export default __webpack_public_path__ + "static/media/footykids.f279841f.svg";